import React from 'react'
import Reflux from 'reflux'
import {
	Card,
	CardBody,
	CardTitle,
	Table
} from 'reactstrap'
import _ from 'lodash'

import QuantitiesStore from '~/stores/quantities'
// import QuantitiesActions from '~/actions/quantities.js'
import ModalQuantityListRow from '~/modules/modals/quantities/listRow.jsx'
import ModalQuantityListFilterBar from '~/modules/modals/quantities/listFilterBar.jsx'


export default class RecipeQuantitiesModalList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = QuantitiesStore
	}

	render() {
		const quantityList = (
			_.has(this.state, 'quantities')
			&& _.size(this.state.quantities) > 0
		)
			? this.state.quantities.map(
				theQuantity => ((
						this.state.quantityFilterLetter === theQuantity.firstLetter
						|| this.state.quantityFilterLetter === ''
					)
						? (
							<ModalQuantityListRow
								key={theQuantity.quantityID}
								quantityID={theQuantity.quantityID}
								quantityAbbrev={theQuantity.quantityAbbrev}
								quantity={theQuantity.quantity}
							/>
						)
						: null
			))
			: null

		return (
			<Card body inverse color="secondary">
				<CardTitle>
					Existing Quantities
				</CardTitle>
				<CardBody style={{ margin: 0, padding: 0 }}>
					<ModalQuantityListFilterBar />

					<br />
					<br />

					<Table size="sm" striped>
						<thead>
							<tr>
								<th style={{ width: '30%' }}>Abbrev</th>
								<th style={{ width: '50%' }}>Quantity</th>
								<th style={{ width: '10%' }} />
								<th style={{ width: '10%' }} />
							</tr>
						</thead>
						<tbody>
							{quantityList}
						</tbody>
					</Table>
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities/list.jsx